"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.I18nApi = exports.i18nEmpty = void 0;
// Implementations
exports.i18nEmpty = {
    fetchMessages: function () {
        return new Promise(function (resolve, reject) {
            resolve({
                'custom': {}
            });
        });
    }
};
var I18nApi = /** @class */ (function () {
    function I18nApi(http, apiUrl) {
        this.http = http;
        this.apiUrl = apiUrl;
    }
    /** Fetch i18n messages from API */
    I18nApi.prototype.fetchMessages = function (config) {
        return this.http.get(this.apiUrl, config)
            .then(function (res) {
            if (!res.data.messages) {
                throw new Error('Messages not found.');
            }
            return res.data.messages;
        });
    };
    return I18nApi;
}());
exports.I18nApi = I18nApi;
